import React from 'react';
import { TreeDataState, CustomTreeData } from '@devexpress/dx-react-grid';
import { Grid, Table, TableHeaderRow, TableTreeColumn, TableFixedColumns } from '@devexpress/dx-react-grid-material-ui';

const getChildRows = (row, rootRows) => (row ? row.items : rootRows);

class WhatIfTreeGridPres extends React.Component {
  render() {
    const { tableData, stickyLeftColumn } = this.props;

    return (
      <div className="whatif-treegrid">
        {tableData && (
          <Grid rows={tableData.treeRows} columns={tableData.treeColumns}>
            <TreeDataState />
            <CustomTreeData getChildRows={getChildRows} />
            <Table columnExtensions={tableData.tableColumnExtensions} />
            <TableHeaderRow />
            <TableTreeColumn for="columns" />
            <TableFixedColumns leftColumns={stickyLeftColumn} />
          </Grid>
        )}
      </div>
    );
  }
}

export default WhatIfTreeGridPres;
